import type { PogNonCircular } from "@CommonTypes/merchflow/pog/pog";
import type { PsaAisleSplitSuggestion } from "@CommonUtils/psa/aisleSplitGap";

/** `afterBayNo` is 1-based; a seam the pog does not have (the last bay, or past it) is left alone. */
export const withAisleBreak =
  (afterBayNo: number) =>
  (pog: PogNonCircular): PogNonCircular => {
    const { bays } = pog.planogram;
    if (afterBayNo < 1 || afterBayNo >= bays.length) return pog;

    return {
      ...pog,
      planogram: {
        ...pog.planogram,
        bays: bays.map((bay, bayIndex) =>
          bayIndex === afterBayNo - 1 ? { ...bay, splitAfter: true } : bay,
        ),
      },
    };
  };

/** The 1-based bays the pog breaks the aisle after. */
export const aisleBreaksOn = (
  pog: { planogram: { bays: readonly { splitAfter?: boolean }[] } } | null,
) => (pog?.planogram.bays ?? []).flatMap((bay, bayIndex) => (bay.splitAfter ? [bayIndex + 1] : []));

/** Suggestions for seams the canvas does not already break, e.g. one set in the editor but unsaved. */
export const suggestionsNotBrokenOn = (
  suggestions: readonly PsaAisleSplitSuggestion[],
  pog: { planogram: { bays: readonly { splitAfter?: boolean }[] } } | null,
) =>
  suggestions.filter(
    (suggestion) => pog?.planogram.bays[suggestion.afterBayNo - 1]?.splitAfter !== true,
  );
